import { subDays } from "date-fns";
import { SubscriberModel } from "../../subscriber/models/SubscriberModel";
import { IDateRange } from "../../utils/interfaces/DateRangeInterface";
import { IFilterList } from "../../utils/interfaces/FilterListInterface";
import { toPartialQueryString } from "../../utils/parsers/QueryString";
import { BillingStatusEnum } from "../enums/BillingStatusEnum";
import { BillingTypeModel } from "./BillingTypeModel";

interface BillingStatusEnumWrapper {
    enum: number;
    description: string;
}

export class BillingListFilterFormModel implements IFilterList {
    subscriber: SubscriberModel = new SubscriberModel()
    date: IDateRange = {start: subDays(new Date(), 30), end: new Date()}
    typeList: BillingTypeModel[]|number[] = []
    status: BillingStatusEnumWrapper = {
        enum: BillingStatusEnum.All,
        description: "Todos"
    }

    constructor(b?:Partial<BillingListFilterFormModel>) {
        Object.assign(this, b)
    }

    isFilterFilled():boolean {
        return (!!this.subscriber && !!this.subscriber.id)||
            !!this.date.start ||
            !!this.date.end ||
            !!this.typeList.length;
    }

    toPartialQueryString():string {
        const tmp = {
            ...this,
            status: this.status.enum,
            date: undefined,
            subscriber: undefined,
            idSubscriber: this.subscriber?.id,
            dueStartDate: this.date.start ? this.date.start!.toISOString() : undefined,
            dueEndDate: this.date.end ? this.date.end!.toISOString(): undefined, 
            typeList: (this.typeList as BillingTypeModel[]).map((t) => t.id).join(',')
        }

        return toPartialQueryString(tmp)
    }
}
